export default "__VITE_ASSET__Cg3LaJ0Z__"